/**
 * @file 实验抽样信息前端存储
 */

/* global App, getApp, swan */
const GATEWAY_SIDS_KEY = 'LVLIN_GATEWAY_SIDS';
const GATEWAY_SIDS_RESULT = 'LVLIN_GATEWAY_SIDS_RESULT';

/**
 * 从响应头内获取实验信息
 * @param {Object} header 响应头
 * @param {String} sid 实验sid (新法典视频实验)
 */

const setExpFromHeader = (header = {}) => {
  const app = getApp() || {};
  const {
    zhishiSids,
    codeSid
  } = app.globalData || {};
  if (Object.prototype.hasOwnProperty.call(header, 'X-Gateway-Sids') || Object.prototype.hasOwnProperty.call(header, 'x-gateway-sids') || codeSid) {
    let gatewaySids = '';
    gatewaySids = header['X-Gateway-Sids'] || header['x-gateway-sids'] || '';
    if (codeSid) {
      if (gatewaySids) {
        gatewaySids += `-${codeSid}`;
      } else {
        gatewaySids = codeSid;
      }
    }
    // sid改变，设置新的sid信息
    if (gatewaySids && zhishiSids !== gatewaySids) {
      app.globalData.zhishiSids = gatewaySids;
      app.$api.setStorageSync(GATEWAY_SIDS_KEY, gatewaySids);
    }
  }
};

/**
 * 从响应头内获取实验信息
 * @param {Object} sidsResult 实验结果
 */

const setExpResult = sidsResult => {
  let result = sidsResult && Object.prototype.toString.call(sidsResult) === '[object Object]' ? sidsResult : {};
  try {
    const app = getApp() || {};
    let {
      lawExpTags
    } = app.globalData || {};
    let sidsResultString = JSON.stringify(result);
    // sid改变，设置新的sids-实验结果
    if (JSON.stringify(lawExpTags) !== sidsResultString) {
      app.globalData.lawExpTags = result;
      app.$api.setStorageSync(GATEWAY_SIDS_RESULT, sidsResultString);
    }
  } catch (err) {}
};

/**
 * 获取本地存储的sid
 * @returns {Array} sid数组
 */

const getSids = () => {
  const app = getApp() || {};
  let gatewaySids = app && app.globalData && app.globalData.zhishiSids;
  if (!gatewaySids) {
    gatewaySids = app.$api && app.$api.getStorageSync(GATEWAY_SIDS_KEY);
  }
  if (typeof gatewaySids === 'string') {
    return gatewaySids.split('-');
  }
  return Array.isArray(gatewaySids) ? gatewaySids : [];
};

/**
 * 获取本地存储的sid结果
 * @returns {Array} sid数组
 */

const getSidsResult = () => {
  const app = getApp() || {};
  let lawExpTags = app && app.globalData && app.globalData.lawExpTags;
  if (!lawExpTags) {
    lawExpTags = app.$api && app.$api.getStorageSync(GATEWAY_SIDS_RESULT);
    lawExpTags && (lawExpTags = JSON.parse(lawExpTags));
  }
  return lawExpTags || {};
};
export { GATEWAY_SIDS_KEY, GATEWAY_SIDS_RESULT, setExpFromHeader, setExpResult, getSids, getSidsResult };